import { Stack } from '@mui/material';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import React, { useState } from 'react';

// import * as ds from './dataService';

import { AttachmentCard } from 'modules/components/layer05';
import { SaveReportAttachmentModal } from 'modules/components/layer17';


type IStandardAttachment = {
  id: string;
  fileName: string;
  formattedFileSize: string;
};


export type ClientReportAttachmentCardProps = {
  clientReportId: string;
  attachments: (IStandardAttachment & { url: string })[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportAttachmentCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <SaveReportAttachmentModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <ActivityDetailSectionCardBaseLayout.FC
        title='Attachments'
        subTitle='Add Attachments Here'
        actionButton={{
        // open modal to upload
          onClick: () => {
            setIsVisible(() => true);
          },
          text: 'Add Attachment'
        }}
        editActionButton={null}
        isEmpty={
          props.attachments.length < 1
            ? true
            : false
        }
        boxProps={{
          flex: '1 1 0'
        }}
      >
        <Stack
          flex='1 1 0'
          direction='column'
          rowGap='1.5rem'
        >
          {
            props.attachments.map((node, i) => (
              <AttachmentCard.FC
                id={node.id}
                key={node.id ?? i}
                url={node.url}
                fileName={node.fileName}
                formattedFileSize={node.formattedFileSize}
                handleDelete={() => {}}
              />
            ))
          }
        </Stack>
      </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
